module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAzMSAyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjguMDM0IDcuNzVsLTYuMDcxLTYuMjI2TDIzLjAzNy40NzZsNy44MjYgOC4wMjctNy44MjYgOC4wMi0xLjA3NC0xLjA0NyA2LjA3NS02LjIyNkgwdi0xLjV6IiBmaWxsPSIjMEYyODQwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/forward-arrow.svg
// module id = 1Fv3
// module chunks = 1